<template>
    <div
            class="property-mls-sponsor-logo"
    >
        <div
                v-if="logoSrc"
                class="organization-logo"
        >
            <avatar
                    :src="logoSrc"
                    :size="avatarSize"
                    class="organization-logo-avatar"
            />
        </div>
    </div>
</template>

<script>
    import './PropertyMlsSponsorLogo.scss';
    import {mapGetters} from "vuex";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
    import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";

    export default {
        name: 'PropertyMlsSponsorLogo',
        mixins: [
            IsMobileMixin,
        ],
        data() {
            return {
                mlsSponsorLogoUuid: '',
                loading: false,
            };
        },
        computed: {
            ...mapGetters({
                getOrganization: 'getOrganization',
                refreshToken: 'refreshToken',
            }),
            avatarSize() {
                return (this.isMobile || this.isTablet) ? 4 : 6.875;
            },
            organizationSettings() {
                return this.getOrganization?.settings;
            },
            getMlsAccess() {
                return this.organizationSettings?.mlsAccess;
            },
            getMlsSponsor() {
                return this.organizationSettings?.mlsSponsor || this.getOrganization?.uuid;
            },
            getOrganizationExists() {
                return this.getOrganization?.exists;
            },
            logoSrc() {
                if (this.loading) {
                    return '';
                }
                if (this.mlsSponsorLogoUuid) {
                    return window.env.MILESTONES_API_HOST + '/file/' +
                        this.mlsSponsorLogoUuid +
                        '?token=' +
                        this.refreshToken;
                }
                if (this.getOrganization?.organizationBranding?.logoUuid) {
                    return window.env.MILESTONES_API_HOST + '/file/' +
                        this.getOrganization.organizationBranding.logoUuid +
                        '?token=' +
                        this.refreshToken;
                }
                return '';
            }
        },
        methods: {
            async fetchOrganizationMlsSponsor() {
                //ToDo create a store property to save this request response
                if (!this.getMlsAccess || (this.getMlsSponsor === this.getOrganization?.uuid)) {
                    return;
                }

                this.loading = true;
                try {
                    let organizationSearch = new AppResourceSearch('Organization');
                    organizationSearch.setSearchData({
                        pagination: 'disabled',
                        limit: 1,
                        include: ['organizationBranding'],
                        filter: new ApiFilter({params: {uuid: this.getMlsSponsor}}),
                    }, false);

                    await organizationSearch.search();
                    if (organizationSearch.appResourceCollection.isNotEmpty) {
                        this.mlsSponsorLogoUuid = organizationSearch.appResourceCollection
                            .getFirst()?.organizationBranding?.logoUuid;
                    }
                } catch (e) {
                    console.error(e);
                }

                this.loading = false;
            }
        },
        created() {
            if (this.getOrganizationExists) {
                this.fetchOrganizationMlsSponsor();
            }
        },
    };
</script>
